import React from "react";

//Shared behaviour for the popup and the photo viewer while open: locks page scrolling, moves focus in,
//keeps Tab inside, closes on Escape, and puts focus back where it was on close
const useDialog = (isOpen, onClose, dialogRef, initialFocusRef) => {
  const onCloseRef = React.useRef(onClose);
  onCloseRef.current = onClose;

  React.useEffect(() => {
    if (!isOpen) {
      return undefined;
    }
    const previousFocus = document.activeElement;
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    (initialFocusRef && initialFocusRef.current ? initialFocusRef.current : dialogRef.current).focus();

    const onKeyDown = (e) => {
      if (e.key === "Escape") {
        e.stopPropagation();
        onCloseRef.current();
        return;
      }
      if (e.key === "Tab") {
        const focusable = [...dialogRef.current.querySelectorAll("a[href], button:not([disabled])")];
        if (focusable.length === 0) {
          e.preventDefault();
          return;
        }
        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        if (e.shiftKey && document.activeElement === first) {
          e.preventDefault();
          last.focus();
        }
        else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      }
    };
    document.addEventListener("keydown", onKeyDown);
    return () => {
      document.removeEventListener("keydown", onKeyDown);
      document.body.style.overflow = previousOverflow;
      if (previousFocus && previousFocus.focus) {
        previousFocus.focus({ preventScroll: true });
      }
    };
  }, [isOpen, dialogRef, initialFocusRef]);
};

export default useDialog;
